import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag } from 'antd';

const RecentOrdersSection = ({ 
  orders = [],
  loading = false 
}) => {
  const navigate = useNavigate();
  
  // Skip rendering if no orders
  if (!orders || orders.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-bold text-golden-navy mb-4">Recent Orders</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {loading ? (
              Array(5).fill(0).map((_, index) => (
                <tr key={`loading-${index}`} className="animate-pulse">
                  <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded w-16"></div></td>
                  <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded w-32"></div></td>
                  <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded w-24"></div></td>
                  <td className="px-4 py-4"><div className="h-6 bg-gray-200 rounded w-20"></div></td>
                  <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded w-16"></div></td>
                  <td className="px-4 py-4"><div className="h-6 bg-gray-200 rounded w-16"></div></td>
                </tr>
              ))
            ) : (
              orders.slice(0, 5).map((order, index) => (
                <tr key={order.id || index} className="hover:bg-gray-50">
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">#{order.id || index+1001}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                    {order.delivery_first_name || 'Customer'} {order.delivery_last_name || (index + 1)}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                    {new Date(order.property_date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <Tag color={
                      order.order_status === 'Completed' ? 'green' : 
                      order.order_status === 'Scheduled' ? 'blue' : 
                      order.order_status === 'Failed' ? 'red' : 'orange'
                    }>
                      {order.order_status || 'Scheduled'}
                    </Tag>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                    £{parseFloat(order.order_total).toFixed(2)}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm">
                    <button 
                      onClick={() => navigate(`/admin/all-orders/${order.id || index+1001}`)}
                      className="text-indigo-600 hover:text-indigo-900 mr-2"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="mt-4 text-right">
          <button 
            onClick={() => navigate('/admin/all-orders')}
            className="text-sm text-golden-navy font-medium hover:underline"
          >
            View All Orders →
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecentOrdersSection;